<template>
    <div>
        <template v-if="payment_preference == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Virtual Company Payment Preference  </h1>
            </div>
            <div class="global-main">
                <form id="paymentPreferenceForm" @submit.prevent="addPaymentPreferenceData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Company </label>
                            <select v-model="form.company_id" data-live-search="true" name="company_id" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null" >
                                <option value="" selected>Select Company</option>
                                <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">{{ company.name }}</option>
                            </select>
                            <has-error :form="form" field="companyId"></has-error>
                        </div>
                      <div class="form-group">
                        <label> IBFT </label>
                        <select v-model="form.ibft" name="ibft" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('ibft') }">
                          <option value="EMONEY" selected>EMONEY</option>
                          <option value="EASYPAISA">EASYPAISA</option>
                          <option value="FINCA">FINCA</option>
                          <option value="MEEZAN">MEEZAN</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                      </div>
                        <div class="form-group">
                            <label> EPLFT </label>
                            <select v-model="form.eplft" name="eplft" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('eplft') }">
                                <option value="EASYPAISA">EASYPAISA</option>
                                <option value="FINCA">FINCA</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                      <div class="form-group">
                        <label> BILL </label>
                        <select v-model="form.bill" name="bill" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('bill') }">
                          <option value="EMONEY" selected>EMONEY</option>
                          <option value="FINCA">FINCA</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                      </div>
                      <div class="form-group">
                        <label> TOPUP </label>
                        <select v-model="form.topup" name="topup" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('topup') }">
                          <option value="EMONEY" selected>EMONEY</option>
                          <option value="FINCA">FINCA</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                      </div>
                        <div class="form-group">
                            <label> Status </label>
                            <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="" selected>Select Status</option>
                                <option value="ON">ON</option>
                                <option value="OFF">OFF</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/paymentPreferenceList" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="payment_preference === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="payment_preference === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    company_id: "",
                    charges: "2500",
                    ibft: "EASYPAISA",
                    eplft: "EASYPAISA",
                    bill: "EMONEY",
                    topup: "EMONEY",
                    status: "ON",
                }),
                companies: {},
              payment_preference: null,
            };
        },
        methods: {
            addPaymentPreferenceData() {
                this.$Progress.start();
              Swal.fire({
                title: 'Are you sure?',
                text: 'Payment Preference for selected company will be added!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Proceed'
              }).then((result) => {
                if (result.value) {
                  this.form
                      .post("api/addPaymentPreference")
                      .then((res) => {
                        if (res.status == 200) {
                          if (res.data.code == 200) {
                            this.resetForm();
                            this.$Progress.finish();
                            this.showToastBox("success", "Payment Preference added successfully");
                            this.$router.push("/paymentPreferenceList");
                          } else {
                            this.showToastBox("error", res.data.message);
                          }
                        } else {
                          this.$Progress.fail();
                          this.showAlertBox("error", "Some error in your form data");
                          $(this.$el).find('.selectpicker').selectpicker('refresh');
                        }
                      }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                  })
                      .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                      });
                }else{this.$router.go(this.$router.currentRoute);}
              })

            },
            resetForm() {
                this.form.companyId = "";
                this.form.charges = "";
                this.form.status = "";
            },
            getPaymentPreferenceData() {
                axios
                    .get("/api/transactionFeeData")
                    .then((res) => {
                        this.companies = res.data;
                    })
                    .then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        console.log(err);
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("payment_preference")
                .then((result) => {
                    this.payment_preference = result.payment_preference;
                })
                .then((result) => {
                    if (this.payment_preference == true) {
                        this.getPaymentPreferenceData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
